export default __webpack_public_path__ + "static/3-b141918a147ab1091d363f49c374743f.png";